import { render, staticRenderFns } from "./tax-category-detail.vue?vue&type=template&id=98d3c95e&scoped=true&"
import script from "./tax-category-detail.vue?vue&type=script&lang=js&"
export * from "./tax-category-detail.vue?vue&type=script&lang=js&"
import style0 from "./tax-category-detail.vue?vue&type=style&index=0&id=98d3c95e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d3c95e",
  null
  
)

export default component.exports